/* import __COLOCATED_TEMPLATE__ from './company-profile-teams-manager.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-company-teams-manager';

class CompanyProfileTeamsManager extends Component {
  @tracked isAddingTeam = false;
  @tracked isEditingTeam = false;

  get className() {
    return CLASS_NAME;
  }

  get classNames() {
    return clsx(
      this.args.class,
      this.className,
    );
  }

  get noTeamsClassNames() {
    const className = `${this.className}__no-teams-container`;
    return this.currentUserIsCompanyAdminOrAdmin 
      ? `${className}--has-action` 
      : className;
  }

  get actionsDisabled() {
    return this.isAddingTeam
      || this.isEditingTeam
      || this.args.onSaveCompanyTeamTask.isRunning
      || this.args.onDeleteCompanyTeamTask.isRunning
      || this.args.loadCompanyTeamsTask.isRunning;
  }

  get currentUserIsCompanyAdminOrAdmin() {
    const { currentUser } = this.args;
    return currentUser.isCompanyAdmin || currentUser.isAdmin;
  }

  @action
  addTeam() {
    this.isAddingTeam = true;
  }

  @action
  cancelAddTeam() {
    this.isAddingTeam = false;
  }

  @action
  editTeam() {
    this.isEditingTeam = true;
  }

  @action
  cancelEditTeam() {
    this.isEditingTeam = false;
  }
}

export default CompanyProfileTeamsManager;
